import { type Variants } from "framer-motion";

export const listContainerVariants: Variants = {
  hidden: {},
  visible: {
    transition: {
      staggerChildren: 0.1, // Faster stagger keeps the momentum going
    },
  },
};

export const getListItemVariants = (isHorizontal: boolean): Variants => ({
  hidden: {
    opacity: 0,
    x: isHorizontal ? 30 : 0,
    y: isHorizontal ? 0 : 30,
    filter: "blur(4px)",
  },
  visible: {
    opacity: 1,
    x: 0,
    y: 0,
    filter: "blur(0px)",
    transition: {
      duration: 0.8,
      ease: [0.16, 1, 0.3, 1],
    },
  },
});